// extracted by mini-css-extract-plugin
export default {"wrapper":"NumberOfColumn_wrapper__6btj0","left":"NumberOfColumn_left__I4w55","bottom":"NumberOfColumn_bottom__TKknD"};